import React from 'react';
import SEO from '../components/SEO';
import { InfoTicker, OccasionGrid, BrandsTicker } from '../components/Marquees';
import CorporateCategoryGrid from '../components/CategoryGrid';
import ProductGrid from '../components/ProductGrid';
import CataloguesSection from '../components/CataloguesSection';
import { ApproachSection, SignatureSolutions, StatsBar, Differentiators } from '../components/Sections';
import { FAQSection, Testimonials, CaseStudies } from '../components/FaqTestimonials';
import ContactForm from '../components/ContactForm';
import { CORPORATE_CATEGORIES, PRODUCTS, TOP_SELLING, FAQS } from '../mock/mock';
import { Link } from 'react-router-dom';
import { ArrowRight, Sparkles } from 'lucide-react';

const PageHero = () => (
  <section className="relative bg-[#FAF6F1] overflow-hidden">
    <div className="absolute inset-0 pointer-events-none">
      <div className="absolute top-10 -left-10 w-72 h-72 rounded-full pastel-blush opacity-70 blur-3xl" />
      <div className="absolute bottom-0 right-0 w-96 h-96 rounded-full pastel-sage opacity-60 blur-3xl" />
    </div>
    <div className="relative max-w-7xl mx-auto px-4 py-16 md:py-24">
      <div className="grid lg:grid-cols-2 gap-12 items-center">
        <div>
          <div className="inline-flex items-center gap-2 bg-[#F4D5C5] text-[#7A5C4C] px-4 py-1.5 rounded-full text-xs uppercase tracking-widest">
            <Sparkles className="w-3.5 h-3.5" /> Corporate Gifting Studio
          </div>
          <h1 className="font-serif-display text-5xl md:text-6xl lg:text-7xl text-[#2C2416] leading-[1.02] mt-5">
            Corporate gifting,<br /><span className="text-[#C58B76]">thoughtfully done.</span>
          </h1>
          <p className="text-[#5B4A3A] mt-6 max-w-xl text-lg leading-relaxed">Choose from 4,000+ premium gifting options with custom branding, GST billing and PAN India delivery. From welcome kits to Diwali hampers - we handle the entire experience.</p>
          <div className="flex flex-wrap gap-3 mt-8">
            <a href="#enquire" className="btn-primary px-6 py-3 rounded-full text-sm uppercase tracking-widest inline-flex items-center gap-2">Enquire Now <ArrowRight className="w-4 h-4" /></a>
            <a href="#collections" className="btn-outline px-6 py-3 rounded-full text-sm uppercase tracking-widest">Browse Collections</a>
          </div>
        </div>
        <div className="relative">
          <div className="grid grid-cols-2 gap-4">
            <img
              src="https://images.unsplash.com/photo-1668127494486-f27a1d2b88f9"
              alt="Premium corporate employee welcome kit hamper by WrapYourWish"
              width="300"
              height="400"
              className="rounded-2xl aspect-[3/4] object-cover"
            />
            <img
              src="https://images.unsplash.com/photo-1625552186152-668cd2f0b707"
              alt="Corporate Diwali festive dry fruit gift box"
              width="300"
              height="400"
              className="rounded-2xl aspect-[3/4] object-cover mt-8"
            />
            <img
              src="https://images.unsplash.com/photo-1608755728617-aefab37d2edd"
              alt="Custom executive desk hamper with vacuum insulated bottle"
              width="300"
              height="400"
              className="rounded-2xl aspect-[3/4] object-cover -mt-8"
            />
            <img
              src="https://images.unsplash.com/photo-1694481901573-a970f982ac5e"
              alt="Milestone work anniversary award corporate gift box"
              width="300"
              height="400"
              className="rounded-2xl aspect-[3/4] object-cover"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
);

const CorporateGifting = () => {
  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: FAQS.map((f) => ({
      '@type': 'Question',
      name: f.q,
      acceptedAnswer: {
        '@type': 'Answer',
        text: f.a,
      },
    })),
  };

  return (
    <main>
      <SEO
        title="Corporate Gifting Companies in Delhi NCR & Pan-India | WrapYourWish"
        description="Elevate your workplace with bespoke corporate gifting in Delhi NCR & Pan India. Employee onboarding welcome kits, client appreciation hampers & festive gifts with GST billing."
        keywords="corporate gifting companies in Delhi NCR, employee onboarding kit suppliers India, bulk client gift hampers, corporate gifts Delhi NCR, corporate gifts Gurgaon, corporate gifts Bangalore, GST billing corporate gifts"
        canonicalUrl="https://wrapyourwish.com/corporate-gifting"
        schemas={[faqSchema]}
      />
      <PageHero />
      <InfoTicker />
      <div id="collections" />
      <CorporateCategoryGrid items={CORPORATE_CATEGORIES} />
      <CataloguesSection />
      <ProductGrid title="Corporate Gifting Solutions" subtitle="Choose from a wide range of over 4,000 corporate gifting options" products={PRODUCTS.slice(0, 8)} />
      <OccasionGrid />
      <ApproachSection />
      <StatsBar />
      <ProductGrid title="Top Selling Corporate Gifts" subtitle="Our popular promotional corporate gifts" products={TOP_SELLING} />
      <BrandsTicker />
      <SignatureSolutions />
      <Differentiators />
      <Testimonials />
      <CaseStudies />
      <FAQSection />
      <ContactForm />
    </main>
  );
};

export default CorporateGifting;
